const getters = {
  headerHeading: (state) => {
    const { discount, length, partner, isRedeemable } = state.current

    if (typeof discount === 'object') {
      if (discount.header?.heading) {
        return discount.header.heading
      }

      return `Clientes ${partner.name} tem uma <span class="color-2">condição muito especial</span> para seguir utilizando a Playkids!`
    }

    switch (discount) {
      case 0:
        return 'Assine PlayKids!'

      case 50:
        return 'Assine PlayKids<br>pela <span class="color-2">metade do preço!</span>'

      case 100:
        if (length) {
          return partner
            ? `<span class="color-2">${length} dias grátis</span> para<br>clientes ${partner.name}!`
            : `Assine PlayKids<br>com <span class="color-2">${length} dias grátis!</span>`
        }
    }

    if (isRedeemable) {
      return `Assinantes ${partner.name} tem <span class="color-2">acesso completo ao</span> PlayKids app!`
    }

    return `Assine PlayKids <br>com <span class="color-2">${discount}%</span> de desconto!`
  },

  headerText: (state) => {
    const { discount, partner } = state.current

    if (discount.header?.text) {
      return discount.header.text
    }

    if (partner) {
      return (typeof discount === 'object')
        ? `${partner.name} e Playkids oferecem uma oferta especial para você:`
        : `PlayKids e ${partner.name} se uniram para levar mais <strong>diversão e aprendizado para sua casa.</strong> Aproveite o melhor conteúdo infantil!`
    }

    return discount > 0
      ? 'Promoção por tempo limitado para levar mais <strong>diversão e aprendizado para sua casa.</strong> Aproveite o melhor conteúdo infantil!'
      : 'Leve mais <strong>diversão e aprendizado para sua casa.</strong> Aproveite o melhor conteúdo infantil!'
  }
}

export default getters
